module.exports = "/img/6.fe94e131.png";